import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ExperienceItemIds } from '@consts';

interface ExperienceSliceState {
  current: ExperienceItemIds;
}

const initialState: ExperienceSliceState = {
  current: ExperienceItemIds.non_exist,
};

export const ExperienceSlice = createSlice({
  name: 'experience',
  initialState,
  reducers: {
    setExperience(state, { payload }: PayloadAction<ExperienceItemIds>) {
      state.current = payload;
    },
  },
});

export default ExperienceSlice.reducer;
